import { NATURAL_PERSON } from 'data-layer-cr/dist/constants/customerTypes';

export type ClientLocalData = {
  idType: string;
  firstName: string;
  lastName: string;
  socialReason: string;
};

export const getUserSocialReason = (data: ClientLocalData): string => {
  const fullname = `${data.firstName} ${data.lastName}`;
  const socialReason = data.socialReason || data.firstName;
  if (data.idType === NATURAL_PERSON) {
    return fullname;
  }
  return socialReason;
};

export function getUserAgentBrowser(): string {
  const { userAgent } = navigator;
  if (userAgent.indexOf('Chrome') > -1) {
    return 'Chrome';
  }
  if (userAgent.indexOf('Safari') > -1 && userAgent.indexOf('Chrome') === -1) {
    return 'Safari';
  }
  if (userAgent.indexOf('Firefox') > -1) {
    return 'Firefox';
  }
  if (userAgent.indexOf('Edge') > -1) {
    return 'Edge';
  }
  if (userAgent.indexOf('Opera') > -1 || userAgent.indexOf('OPR') > -1) {
    return 'Opera';
  }
  return 'Unknown';
}

export function getUserOS(): string {
  const { userAgent } = navigator;
  if (userAgent.includes('Windows')) {
    return 'Windows';
  }
  if (userAgent.includes('Mac')) {
    return 'MacOS';
  }
  if (userAgent.includes('Linux')) {
    return 'Linux';
  }
  return 'Unknown';
}
